module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "simple-card",
    staticStyle: {
      "background-color": "#F8F8F8"
    }
  }, [_c('div', [_c('i', {
    class: _vm.icon,
    style: ('font-size: 40px; height: 100%; padding: 12px; color:' + _vm.iconColor + '!important')
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-card-content"
  }, [_c('h3', {
    staticClass: "simple-card-title",
    staticStyle: {
      "margin": "0 0 7px 0 !important"
    }
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.previous) ? _c('span', {
    staticStyle: {
      "font-size": "27px",
      "font-weight": "bold",
      "color": "#3a3a3a",
      "margin": "0px"
    }
  }, [_vm._v(_vm._s(_vm.previous) + " "), _c('i', {
    staticClass: "fa fa-arrow-right"
  })]) : _vm._e(), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "27px",
      "font-weight": "bold",
      "color": "#3a3a3a",
      "margin": "10px 10px 10px 0"
    }
  }, [_vm._v(_vm._s(_vm.value))])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-da949fd8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-da949fd8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/rating/cards/InfoCard.vue
// module id = 1476
// module chunks = 1